


import ReactHTMLTableToExcel from "react-html-table-to-excel"
import { useTranslation } from "react-i18next"
import moment from 'moment'

export const OfficialDashboardExcel = (props) => {
    const { name, ActiveButton, tableData, ToDate, FromDate, WardName, ZoneNameDDLID, WorkType } = props

    const { t } = useTranslation()

    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-OfficialDashboardExcel"
                className="btn btn-primary download-table-xls-button mt-4 btn btn-export btn-md mr-1 mb-2 ml-1"
                filename={name}
                sheet={name}
                buttonText="Excel Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-OfficialDashboardExcel" style={{ display: 'none', width: '47%' }}>

                <h5><span>&emsp;</span></h5>

                <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name}</h4>
               <h4 style={{ textAlign: 'center', fontSize: 16 }}>
                    From Date - {FromDate ? moment(FromDate).format('DD-MM-YYYY') : ''}
                    <span>&emsp;</span>
                    | To Date - {ToDate ? moment(ToDate).format('DD-MM-YYYY') : ''}
                    <span>&emsp;</span>
                </h4>
          
                <tr><td></td></tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                        <th className="sr_no_col" style={{ width: "4%",verticalAlign:'middle' }}>{t('Dashboard.Pcmc_Assets.Sr_No')}</th>

                        {
                            ActiveButton == 'कर्मचारी' ?
                                <>
                                    <th>{t('AdminDashboard.Admin_Sidebar_Name.Designation')}</th>
                                    <th>{t('Dashboard.Work_Assigned_by_Officials.Officer_Name')}</th>
                                    <th>{t('Dashboard.Pcmc_Assets.Zone_Name')}</th>

                                </>
                                :
                                <>
                                    <th style={{verticalAlign:'middle'}}>{t('Dashboard.Pcmc_Assets.Zone_Name')}</th>
                                    <th>{t('Dashboard.Work_Assigned_by_Officials.Contractor_Name')}</th>
                                </>
                        }

                      
                        <th>{t('EmployeeAndContractor.Total_Assign_Works')}</th>
                        <th>{t('EmployeeAndContractor.Total_works_Completed')}</th>
                        <th>{t('EmployeeAndContractor.Total_Pending_Works')}</th>
                        <th>{t('EmployeeAndContractor.0_to_7_days')}</th>
                        <th>{t('EmployeeAndContractor.7_to_15_days')}</th>
                        <th>{t('EmployeeAndContractor.15_to_30_days')}</th>
                        <th>{t('EmployeeAndContractor.30_to_90_days')}</th>
                        <th>{t('EmployeeAndContractor.90_to_180_days')}</th>
                        <th>{t('EmployeeAndContractor.1_year')}</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        tableData && tableData.data && tableData.data.length > 0 && tableData.data.map((zone, j) => {
                            return zone?.rowdata?.map((i, officerIndex) => {
                                const rowSpan = zone?.rowdata?.length || 1;
                                return (
                                    <tr className="text-center" key={ActiveButton == 'कर्मचारी' ? `${zone?.designation}-${officerIndex}` : `${zone?.zoneName}-${officerIndex}`}>

                                        {officerIndex === 0 ? (
                                            <>
                                                <td rowSpan={rowSpan} className="verticalAllign">{j + 1}</td>
                                                {
                                                    ActiveButton == 'कर्मचारी' ?
                                                        <td rowSpan={rowSpan} className="verticalAllign">{zone?.designation}</td>
                                                        :
                                                        <td rowSpan={rowSpan} className="verticalAllign">{zone?.zoneName}</td>

                                                }
                                            </>
                                        ) : null}

                                        {
                                            ActiveButton == 'कर्मचारी' ?
                                                <>
                                                    <td>{i.employeeName ? i.employeeName : '-'}</td>
                                                    <td>{i.zoneName ? i.zoneName : '-'}</td>
                                                </>
                                                :
                                                <>
                                                    <td>{i.employeeName ? i.employeeName : '-'}</td>
                                                </>
                                        }


                                        <td className='text-center fw-bold' style={{ color: '#4d8ae1' }}>
                                            <span className='cursor-pointer fw-bold'
                                            >
                                                {i.totalAllCount ? i.totalAllCount : 0}
                                            </span>
                                        </td>
                                        <td className='text-center fw-bold'>
                                            <span className='cursor-pointer fw-bold' style={{ color: 'green' }}
                                           >
                                                {i.completedCount ? i.completedCount : 0}
                                            </span>
                                        </td>
                                        <td className='text-center fw-bold'>
                                            <span className='cursor-pointer fw-bold' style={{ color: 'orangered' }}
                                            >
                                                {i.pendingCount ? i.pendingCount : 0}
                                            </span>
                                        </td>
                                        <td className='text-center fw-bold' style={{ color: '#fab74b' }}>
                                            <span className='cursor-pointer'
                                            >
                                                {i.pending_0_7DaysCount ? i.pending_0_7DaysCount : 0}
                                            </span>
                                        </td>

                                        <td className='text-center fw-bold' style={{ color: '#f7526f' }}>
                                            <span className='cursor-pointer'
                                            >
                                                {i.pending_7_15DaysCount ? i.pending_7_15DaysCount : 0}
                                            </span>
                                        </td>

                                        <td className='text-center fw-bold' style={{ color: '#30a1f5' }}>
                                            <span className='cursor-pointer'
                                            >
                                                {i.pending_15_30DaysCount ? i.pending_15_30DaysCount : 0}
                                            </span>
                                        </td>

                                        <td className='text-center fw-bold' style={{ color: '#db0008' }}>
                                            <span className='cursor-pointer'
                                           >
                                                {i.pending_30_90DaysCount ? i.pending_30_90DaysCount : 0}
                                            </span>
                                        </td>

                                        <td className='text-center fw-bold' style={{ color: '#147b09' }}>
                                            <span className='cursor-pointer'
                                            >
                                                {i.pending_90_180DaysCount ? i.pending_90_180DaysCount : 0}
                                            </span>
                                        </td>

                                        <td className='text-center fw-bold' style={{ color: '#6464ed' }}>
                                            <span className='cursor-pointer'
                                           >
                                                {i.pending_365DaysCount ? i.pending_365DaysCount : 0}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            });
                        })
                    }

                </tbody>

            </table>
        </div>
    )
}